import { redirect, createFileRoute } from '@tanstack/react-router';
import { Signup } from '@/pages/auth/signup/Signup';
import { signupSearchSchema } from '@/pages/auth/signup/signupSearch';
import { isSignupIncomplete } from '@/lib/incomplete-signup';
import { appOriginUrlForCurrentPage } from '@/pages/auth/social/socialOrigin';

export const Route = createFileRoute('/signup')({
	validateSearch: signupSearchSchema,
	beforeLoad: ({ context }) => {
		// A tenant host cannot open any provider (`social/socialOrigin.ts`), so the page moves first.
		const appOriginUrl = appOriginUrlForCurrentPage();
		if (appOriginUrl) throw redirect({ href: appOriginUrl });
		const { authenticated, user, companies } = context.globalStore.getState();
		// A provider tap signs the person in before their signup is finished, and the step that
		// finishes it lives on this route - so an incomplete session belongs here, not at the app.
		// A finished session with no workspace is still mid-onboarding: the company form pushed
		// itself onto this route's history entry, and the back button off it has to land on the
		// signup screen rather than be bounced to a dashboard the person has never seen.
		if (authenticated && !isSignupIncomplete(user) && companies.length > 0) {
			throw redirect({ to: '/' });
		}
	},
	component: Signup,
});
